import React, { useState } from "react";
import { AppBar, Toolbar, Button, Hidden } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Logo from "../../images/logo.png";

const useStyles = makeStyles((theme) => ({
  navbar: {
    background: "rgb(1, 6, 25)", // Dark navy blue background
    boxShadow: "none",
    padding: "1.5rem 5%",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: "2rem",
    flexGrow: 1,
  },
  logo: {
    height: "10rem",
    width: "12rem",
    cursor: "pointer",
    borderRadius: "10rem",
  },
  textButton: {
    fontSize: "1.5rem",
    textTransform: "none",
    color: "#ff0080", // Neon blue text
    "&:hover": {
      color: "#ff0080", // Neon pink hover effect
    },
  },
  connectButton: {
    fontSize: "1.2rem",
    padding: "0.75rem 2rem",
    background: "#ff0080", // Neon pink button
    color: "#ffffff", // White text for contrast
    borderRadius: "0.5rem",
    whiteSpace: "nowrap",
    "&:hover": {
      background: "#ff4da6", // Lighter neon pink on hover
    },
  },
  mobileMenu: {
    display: "flex",
    flexDirection: "column", // Stack the buttons vertically on smaller screens
    alignItems: "center", // Center the buttons
    width: "100%",
  },
}));

const Navbar = () => {
  const classes = useStyles();
  const [walletAddress, setWalletAddress] = useState(null); // Track the connected wallet

  const connectWallet = async () => {
    try {
      if (window.solana && window.solana.isPhantom) {
        if (!walletAddress) {
          // If wallet is not connected, prompt the user to connect
          const response = await window.solana.connect();
          setWalletAddress(response.publicKey.toString());
        } else {
          // If wallet is already connected, disconnect it
          await window.solana.disconnect();
          setWalletAddress(null);
        }
      } else {
        alert("Please install Phantom Wallet.");
      }
    } catch (error) {
      alert("Error connecting/disconnecting wallet: " + error.message);
    }
  };

  return (
    <AppBar position="static" className={classes.navbar}>
      <Toolbar className={classes.toolbar}>
        <div className={classes.leftSection}>
          <img src={Logo} alt="Logo" className={classes.logo} />
        </div>

        {/* Desktop view */}
        <Hidden smDown>
          <div style={{ display: 'flex' }}>
            <Button className={classes.textButton}>Pre-sale</Button>
            <Button className={classes.textButton}>About</Button>
            <Button className={classes.textButton}>Roadmap</Button>
            <Button className={classes.connectButton} onClick={connectWallet}>
              {walletAddress ? `${walletAddress.slice(0, 10)}...` : "Connect Wallet"}
            </Button>
          </div>
        </Hidden>

        {/* Mobile view (Column Layout) */}
        <Hidden mdUp>
          <div className={classes.mobileMenu}>
            <Button className={classes.textButton}>Pre-sale</Button>
            <Button className={classes.textButton}>About</Button>
            <Button className={classes.textButton}>Roadmap</Button>
            <Button className={classes.connectButton} onClick={connectWallet}>
              {walletAddress ? `${walletAddress.slice(0, 10)}...` : "Connect Wallet"}
            </Button>
          </div>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
